import { useMemo } from "react";
import { useMobileContentResource } from "../../../../../../../core/resource/MobileResourceProvider";

import {
  createAdultPassengerSchema,
  createChildPassengerSchema,
  createInfantPassengerSchema,
} from "../../../../utils";
import { FlightPrebookPassengerFormValue } from "../../../types";

export function usePassengerSchema(
  defaultValues: FlightPrebookPassengerFormValue,
  departureDate: Date,
  isTripDomesticID: boolean
) {
  const { CorporateFlightPrebookForm: crf, CorporateGeneralErrorMessage: cre } =
    useMobileContentResource();

  return useMemo(() => {
    const cr = { ...crf, ...cre };
    switch (defaultValues.type) {
      case "ADULT":
        return createAdultPassengerSchema(cr, departureDate, isTripDomesticID);
      case "CHILD":
        return createChildPassengerSchema(cr, departureDate, isTripDomesticID);
      case "INFANT":
        return createInfantPassengerSchema(cr, departureDate, isTripDomesticID);
      default:
        return createAdultPassengerSchema(cr, departureDate, isTripDomesticID);
    }
  }, [defaultValues.type, departureDate, isTripDomesticID, crf, cre]);
}
